'use strict';

var _objectSpread = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var errCode = require('err-code');

var _require = require('ipfs-unixfs'),
    UnixFS = _require.UnixFS;

var persist = require('../../utils/persist');

var _require2 = require('ipld-dag-pb'),
    DAGNode = _require2.DAGNode,
    DAGLink = _require2.DAGLink;

var parallelBatch = require('it-parallel-batch');

var mh = require('multihashing-async').multihash;
/**
 * @typedef {import('../../types').BlockAPI} BlockAPI
 * @typedef {import('../../types').File} File
 * @typedef {import('../../types').ImporterOptions} ImporterOptions
 * @typedef {import('../../types').Reducer} Reducer
 * @typedef {import('../../types').DAGBuilder} DAGBuilder
 * @typedef {import('../../types').FileDAGBuilder} FileDAGBuilder
 */

/**
 * @type {{ [key: string]: FileDAGBuilder}}
 */


var dagBuilders = {
  flat: require('./flat'),
  balanced: require('./balanced'),
  trickle: require('./trickle')
};
/**
 * @param {File} file
 * @param {BlockAPI} block
 * @param {ImporterOptions} options
 */

function buildFileBatch(_x, _x2, _x3) {
  return _buildFileBatch.apply(this, arguments);
}
/**
 * @param {File} file
 * @param {BlockAPI} block
 * @param {ImporterOptions} options
 */


function _buildFileBatch() {
  _buildFileBatch = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file, block, options) {
    var count, previous, bufferImporter, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, entry;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            count = -1;

            if (typeof options.bufferImporter === 'function') {
              bufferImporter = options.bufferImporter;
            } else {
              bufferImporter = require('./buffer-importer');
            }

            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context.prev = 4;
            _iterator = _asyncIterator(parallelBatch(bufferImporter(file, block, options), options.blockWriteConcurrency));

          case 6:
            _context.next = 8;
            return _awaitAsyncGenerator(_iterator.next());

          case 8:
            if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
              _context.next = 25;
              break;
            }

            entry = _step.value;
            count++;

            if (!(count === 0)) {
              _context.next = 16;
              break;
            }

            previous = entry;
            return _context.abrupt("continue", 22);

          case 16:
            if (!(count === 1 && previous)) {
              _context.next = 20;
              break;
            }

            _context.next = 19;
            return previous;

          case 19:
            previous = null;

          case 20:
            _context.next = 22;
            return entry;

          case 22:
            _iteratorAbruptCompletion = false;
            _context.next = 6;
            break;

          case 25:
            _context.next = 31;
            break;

          case 27:
            _context.prev = 27;
            _context.t0 = _context["catch"](4);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 31:
            _context.prev = 31;
            _context.prev = 32;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context.next = 36;
              break;
            }

            _context.next = 36;
            return _awaitAsyncGenerator(_iterator.return());

          case 36:
            _context.prev = 36;

            if (!_didIteratorError) {
              _context.next = 39;
              break;
            }

            throw _iteratorError;

          case 39:
            return _context.finish(36);

          case 40:
            return _context.finish(31);

          case 41:
            if (!previous) {
              _context.next = 45;
              break;
            }

            previous.single = true;
            _context.next = 45;
            return previous;

          case 45:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 27, 31, 41], [32,, 36, 40]]);
  }));
  return _buildFileBatch.apply(this, arguments);
}

var reduce = function reduce(file, block, options) {
  /**
   * @type {Reducer}
   */
  function reducer(_x4) {
    return _reducer.apply(this, arguments);
  }

  function _reducer() {
    _reducer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(leaves) {
      var leaf, _yield$block$get, _buffer, multihash, f, links, node, buffer, cid;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(leaves.length === 1 && leaves[0].single && options.reduceSingleLeafToSelf)) {
                _context2.next = 15;
                break;
              }

              leaf = leaves[0];

              if (!(leaf.cid.codec === 'raw' && (file.mtime !== undefined || file.mode !== undefined))) {
                _context2.next = 14;
                break;
              }

              _context2.next = 5;
              return block.get(leaf.cid, options);

            case 5:
              _yield$block$get = _context2.sent;
              _buffer = _yield$block$get.data;
              leaf.unixfs = new UnixFS({
                type: 'file',
                mtime: file.mtime,
                mode: file.mode,
                data: _buffer
              });
              multihash = mh.decode(leaf.cid.multihash);
              _buffer = new DAGNode(leaf.unixfs.marshal()).serialize();
              _context2.next = 12;
              return persist(_buffer, block, _objectSpread({}, options, {
                codec: 'dag-pb',
                hashAlg: multihash.name,
                cidVersion: options.cidVersion
              }));

            case 12:
              leaf.cid = _context2.sent;
              leaf.size = _buffer.length;

            case 14:
              return _context2.abrupt("return", {
                cid: leaf.cid,
                path: file.path,
                unixfs: leaf.unixfs,
                size: leaf.size
              });

            case 15:
              // create a parent node and add all the leaves
              f = new UnixFS({
                type: 'file',
                mtime: file.mtime,
                mode: file.mode
              });
              links = leaves.filter(function (leaf) {
                if (leaf.cid.codec === 'raw' && leaf.size) {
                  return true;
                }

                if (leaf.unixfs && !leaf.unixfs.data && leaf.unixfs.fileSize()) {
                  return true;
                }

                return Boolean(leaf.unixfs && leaf.unixfs.data && leaf.unixfs.data.length);
              }).map(function (leaf) {
                if (leaf.cid.codec === 'raw') {
                  // node is a leaf buffer
                  f.addBlockSize(leaf.size);
                  return new DAGLink('', leaf.size, leaf.cid);
                }

                if (!leaf.unixfs || !leaf.unixfs.data) {
                  // node is an intermediate node
                  f.addBlockSize(leaf.unixfs && leaf.unixfs.fileSize() || 0);
                } else {
                  // node is a unixfs 'file' leaf node
                  f.addBlockSize(leaf.unixfs.data.length);
                }

                return new DAGLink('', leaf.size, leaf.cid);
              });
              node = new DAGNode(f.marshal(), links);
              buffer = node.serialize();
              _context2.next = 21;
              return persist(buffer, block, options);

            case 21:
              cid = _context2.sent;
              return _context2.abrupt("return", {
                cid: cid,
                path: file.path,
                unixfs: f,
                size: buffer.length + node.Links.reduce(function (acc, curr) {
                  return acc + curr.Tsize;
                }, 0)
              });

            case 23:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _reducer.apply(this, arguments);
  }

  return reducer;
};
/**
 * @type {import('../../types').UnixFSV1DagBuilder<File>}
 */


function fileBuilder(file, block, options) {
  var dagBuilder = dagBuilders[options.strategy];

  if (!dagBuilder) {
    throw errCode(new Error("Unknown importer build strategy name: ".concat(options.strategy)), 'ERR_BAD_STRATEGY');
  }

  return dagBuilder(buildFileBatch(file, block, options), reduce(file, block, options), options);
}

module.exports = fileBuilder;